export default {
  addon: (state) => state.addon,
  addonsaved: (state) => state.addonsaved,
  questions: (state) => state.questions,
  message: (state) => state.message,
  design: (state) => state.design,
  qr: (state) => state.qr,
  listQuestions: (state) => state.listQuestions,
};
